export default {
  vehicleInspections: [],
  vehicleInspection: undefined,
};
